import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_BIDDER_DATA_FAIL = 'la/domain/bidderData/LOAD_FAIL';
export const LOAD_BIDDER_DATA_REQUEST = 'la/domain/bidderData/LOAD_REQUEST';
export const LOAD_BIDDER_DATA_SUCCESS = 'la/domain/bidderData/LOAD_SUCCESS';
export const LOG_OUT_BIDDER = 'LOG_OUT_BIDDER';

export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export type PASSWORD_RESET_SUCCESS_ACTION = TypedActionWithPayload<typeof PASSWORD_RESET_SUCCESS>;
